import { apiConfigs } from "@payping/api";
import type { HandlerType, StatusHandlersTypes } from "@payping/api";
import { setShowTOTPModal } from "@payping/redux/actions";
import { message } from "@payping/web-components";
import * as Sentry from "@sentry/react";

import { userManager } from "@/utils/userManager";
import { setRedirectUrl } from "@/redux/actions/loginRedirect";
// eslint-disable-next-line import-x/no-cycle
import { store } from "./main";

const generalHandler: HandlerType = (error) => {
  // key is a constant because there should be at most one message error from api
  message.error({ content: error.message, duration: 3, key: "api error" });
};

const statusHandlers: StatusHandlersTypes = {
  "401": async () => {
    const currentRoute = `${window.location.pathname}${window.location.search}`;
    await store.dispatch(setRedirectUrl(currentRoute));
    userManager.signinRedirect({
      extraQueryParams: {
        userType: "consumer",
      },
    });
    const currentScope = Sentry.getCurrentScope();
    currentScope.setUser(null);
  },
  "412": async () => {
    await store.dispatch(setShowTOTPModal(true));
  },
  default: generalHandler,
};

const domain = process.env.REACT_APP_DOMAIN || "";

const networkChecker = new Promise<void>((resolve) => {
  resolve();
});

apiConfigs.updateConfig({
  // set 30 second timeout for non-production environments due to low quality of servers
  ...(domain !== "payping.ir" ? { timeout: 30 * 1000 } : {}),
  domain,
  networkChecker,
  statusHandlers,
  timeout: 120 * 1000,
});
